import { ChevronRightIcon } from "@heroicons/react/24/outline";


export const Tertiary = (props) => {
  return (
    <div>
      {
          <button type="button" className="text-sm">
            <div className="flex">
              {props.text}
              <div className="grid content-center">
                <ChevronRightIcon className="h-3 w-3" />
              </div>
            </div>
          </button>
      }
    </div>
  );
};
